const HeaderHero = {
  parts: [
    'backgroundImage',
    'content',
    'container',
    'titleColumn',
    'title',
    'descriptionColumn',
    'description'
  ],
  baseStyle: {
    container: {
      position: 'relative',
      width: 'full',
    },
    backgroundImage: {
      width: 'full',
      height: 'full',
      aspectRatio: {base: '375/468', md: '1440/535'},
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      backgroundRepeat: 'no-repeat',
    },
    content: {
      display: 'flex',
      alignItems: 'flex-start',
      gap: {base: 4, md: 37.5}, // 16px mobile, 150px desktop
      alignSelf: 'stretch',
      px: {base: 5, md: 20}, // 20px mobile, 80px desktop
      py: {base: 14, md: 30}, // 56px mobile, 120px desktop top
      pb: {base: 4, md: 12}, // 24px mobile, 48px desktop bottom
      direction: {base: 'column', lg: 'row'},
      maxWidth: '1440px',
      mx: 'auto',
      width: 'full',
    },
    titleColumn: {
      width: {base: 'full', lg: '39.84%'},
      flexShrink: 0,
    },
    title: {
      color: 'brandColors.greyscale90',
      fontFamily: 'heading',
      fontSize: {base: '40px', md: '6xl', lg: '7xl'}, // 40px mobile, 60px tablet, 72px desktop
      fontStyle: 'normal',
      fontWeight: {base: '500', md: 'normal'}, // 500 mobile, 400 desktop
      lineHeight: {base: '120%', md: '100%'}, // 120% mobile, 100% desktop
      letterSpacing: {base: '-0.4px', md: '-0.6px', lg: '-0.72px'}, // -0.4px mobile, -0.6px tablet, -0.72px desktop
      mb: 0,
    },
    descriptionColumn: {
      display: 'flex',
      pt: {base: 0, lg: 14}, // 0 mobile, 56px desktop (56px / 4 = 14)
      flexDirection: 'column',
      justifyContent: {base: 'center', lg: 'flex-start'},
      alignItems: 'flex-start',
      gap: 3, // 12px
      flex: '1 0 0',
    },
    description: {
      alignSelf: 'stretch',
      color: 'brandColors.greyscale90',
      fontFamily: 'body',
      fontSize: {base: 'md', md: 'lg', lg: 'xl'}, // 16px mobile, 18px tablet, 20px desktop
      fontStyle: 'normal',
      fontWeight: 'normal',
      lineHeight: {base: '160%', md: '150%'}, // 160% mobile, 150% desktop
    },
  },
};

export default HeaderHero;
